import { useCallback, useState } from "react";

import { Source } from "Constant/source";

import { sendHubSporData } from "helpers/Sources/createSource";

import SwalAlertComp from "components/SwalAlert";

import { HUBSPOT_USAGE_TYPE_IDS } from "../SourceCreation.constants";

/**
 * HubSpot CRM flow: name + module, OAuth login, field mapping, then report
 * the created source to the host.
 */
const useHubSpotSource = ({ language, onCreated }) => {
    const [name, setName] = useState("");
    const [selectedModule, setSelectedModule] = useState(null);
    const [isLoginEnabled, setIsLoginEnabled] = useState(false);
    const [isConnected, setIsConnected] = useState(false);
    const [isAuthLoading, setIsAuthLoading] = useState(false);
    const [sourceId, setSourceId] = useState("");

    const failedTitle = language?.delete_swal_modal?.failed ?? "Failed";

    const reset = useCallback(() => {
        setName("");
        setSelectedModule(null);
        setIsLoginEnabled(false);
        setIsConnected(false);
        setIsAuthLoading(false);
        setSourceId("");
    }, []);

    const handleNameChange = (event) => {
        const value = event.target.value;
        setName(value);
        setIsLoginEnabled(value !== "" && value !== null);
    };

    const handleLoginSuccess = async (data) => {
        setIsAuthLoading(true);
        const response = await sendHubSporData({
            name,
            source_type: data?.source_type,
            code: data?.code,
            usage_types: HUBSPOT_USAGE_TYPE_IDS,
            module: selectedModule?.value,
        });
        if (response.status) {
            setIsConnected(true);
            setIsLoginEnabled(false);
            setSourceId(response?.data?.source?.id);
        } else {
            SwalAlertComp({
                title: failedTitle,
                message: response?.message ?? "",
                icon: "error",
            });
        }
        setIsAuthLoading(false);
    };

    const handleMappingSuccess = async (response) => {
        if (!response.status) {
            SwalAlertComp({
                title: failedTitle,
                message: response?.message ?? "",
                icon: "error",
            });
            return;
        }
        SwalAlertComp({
            title: language?.delete_swal_modal?.success ?? "Success",
            message: response.message && response.message,
            icon: "success",
            timer: 3000,
        });
        const createdSourceId = sourceId;
        reset();
        await onCreated({ sourceId: createdSourceId, sourceType: Source.hub });
    };

    return {
        name,
        selectedModule,
        setSelectedModule,
        isLoginEnabled,
        isConnected,
        isAuthLoading,
        setIsAuthLoading,
        sourceId,
        handleNameChange,
        handleLoginSuccess,
        handleMappingSuccess,
        reset,
    };
};

export default useHubSpotSource;
